import {InjectedIntl} from "react-intl"

import ascendingPrice from "@irati/payments/utils/sortByPrice"
import {RewardCatalogueProduct, RewardCatalogueReward} from "@irati/types"

export const buildProductOptions = (reward: RewardCatalogueReward, intl: InjectedIntl) => {
  if (reward) {
    const results = ascendingPrice(reward.products.results)
    return results
      .map(({uuid, price, currency}) => ({
        label: intl.formatNumber(parseFloat(price), {
          style: "currency",
          currency
        }),
        value: uuid
      }))
  }
  return []
}

export const getTotal = (product: RewardCatalogueProduct, recipientsCount: number) => {
  if (!product) {
    return 0
  }
  return product.price * recipientsCount
}
